import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import differenceBy from 'lodash/differenceBy';

import FormError from '../FormError';
import { splitPayment } from '../../api';
import { transformErrorResponse } from '../../helpers/errors';
import ConfirmModal from 'components/ConfirmModal/ConfirmModal';
import Spinner from '../Spinner';

class SplitPayment extends Component {
  state = {
    error: undefined,
    newPurchase: undefined,
    amount: '',
    isOpenModal: false,
    loading: false,
  };

  openModal = (e) => {
    e.preventDefault();
    this.setState({ isOpenModal: true });
  };

  closeModal = () => {
    this.setState({ isOpenModal: false });
  };

  splitPurchase = async () => {
    const { purchase } = this.props;
    const strAmount = this.state.amount;

    try {
      this.setState({
        loading: true,
      });

      const amount = parseFloat(strAmount);
      const { data } = await splitPayment(purchase.id, amount);
      const newPurchase = differenceBy(
        data.linked_from,
        purchase.linked_from,
        'id',
      )[0];
      this.setState({
        newPurchase: newPurchase.id,
        loading: false,
      });
    } catch ({ response }) {
      const error = transformErrorResponse(response.data);
      this.setState({
        error,
        loading: false,
      });

      return;
    }
  };

  handleAmountChange = (e) => {
    this.setState({ amount: e.target.value });
  };

  render() {
    const { error, newPurchase, amount, isOpenModal, loading } = this.state;

    if (newPurchase) {
      const url = `/purchases/${newPurchase}/view`;
      return <Redirect to={url} push />;
    }

    return (
      <React.Fragment>
        <h4>Split Payment</h4>
        <form onSubmit={this.openModal} className="input-group">
          <span className="input-group-addon">$</span>
          <input
            name="amount"
            type="number"
            step="any"
            className="form-control"
            aria-label="Amount"
            placeholder="0.00"
            onChange={this.handleAmountChange}
            value={amount}
            min="0"
            required
          />
          <span className="input-group-btn">
            <button className="btn btn-danger" type="submit">
              Split payment
            </button>
          </span>
        </form>
        {error && <FormError error={error} />}
        <ConfirmModal
          isOpen={isOpenModal}
          title="Confirm splitting the payment"
          description={`Are you sure you would like to proceed in splitting the payment for $${amount}?`}
          onClose={this.closeModal}
          onConfirm={this.splitPurchase}
        />
        {loading && (
          <div
            style={{
              position: 'fixed',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              zIndex: 100,
            }}
          >
            <Spinner showLoader={loading} />
          </div>
        )}
      </React.Fragment>
    );
  }
}

export default SplitPayment;
